import React, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TreasurySummaryTab from "../TreasurySummaryTab/TreasurySummaryTab";
import TreasuryReportingTab from "../TreasuryReportingTab/TreasuryReportingTab";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        backgroundColor: "white",
        height: index == 0 ? "150vh" : "100vh",
      }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TreasuryTabs() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // useEffect(() => {
  //   setValue(0);
  // }, selectedUser);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "capitalize",
              color: "#BCBCBC",
              fontFamily: "Inter",
              fontSize: 14,
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "30px",
              backgroundColor: "#f8f8f8",
              width: "200px",
              position: "relative",

              "&.Mui-selected": {
                backgroundColor: "white",
                color: "#5523D2",
                borderRadius: "6px 6px 0 0 !important",
                textAlign: "center",
                fontSize: 14,
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                borderBottom: 0,
                borderBottomColor: "#FAC800",
                borderBottomWidth: 4,
              },
            },
          }}
        >
          <Tab label="Treasury Summary" {...a11yProps(0)} />
          <Tab label="Reporting" {...a11yProps(1)} />

          <Tab label="Position Reconciliation" {...a11yProps(2)} disabled />
          <Tab label="Nostro Reconciliation" {...a11yProps(3)} disabled />
          <Tab label="Batch Operations" {...a11yProps(4)} disabled />
          <Tab label="Currency Management" {...a11yProps(5)} disabled />
          <Tab label="Gateway Services" {...a11yProps(6)} disabled />
        </Tabs>
      </Box>
      {/* <CustomTabPanel value={value} index={0}>
        Item One
      </CustomTabPanel> */}
      <CustomTabPanel value={value} index={0}>
        <TreasurySummaryTab />
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={1}>
        <LiquidityTab />
      </CustomTabPanel> */}
      {/* <CustomTabPanel value={value} index={2}>
        <LendingServiceTab />
      </CustomTabPanel> */}
      <CustomTabPanel value={value} index={1}>
        <TreasuryReportingTab />
      </CustomTabPanel>
    </Box>
  );
}
